/**
 * The catalogues, and nothing else.
 *
 * They are TypeScript rather than JSON on purpose: `as const` gives every key a literal type, so a
 * typo in `t('action.save')` is a compile error rather than a string that renders as its own key.
 * Extraction to an interchange format for translators is a later job (spec/21 §3 asks only that
 * copy is externalised from day one, which it is).
 */
import commonEn from './locales/en/common.js';
import uiEn from './locales/en/ui.js';
/** The namespaces every surface loads. An app adds its own through `extraResources`. */
export const namespaces = ['common', 'ui'];
export const defaultNamespace = 'common';
export const resources = {
    en: { common: commonEn, ui: uiEn },
};
//# sourceMappingURL=catalogues.js.map